var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"row\">\n<div class=\"col-xs-12\">\n<h2>\n<i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\nBooking error\n</h2>\n</div>\n</div>\n<pkp-alert type=\"danger\" show-timestamp=\"true\" ng-if=\"!!fcfsBooking.generalError\">\n{{fcfsBooking.generalError}}\n</pkp-alert>\n<hr/>\n<a class=\"btn btn-primary pull-right\" ng-click=\"fcfsBooking.startNewOne()\">Start new booking</a>\n";
var id1="app/fcfs-booking/error-page.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;